import { useEffect, useRef } from 'react';
import { io, type Socket } from 'socket.io-client';
import { authUtils } from '@shared/utils/axios-instance';
import {
  SELLER_SUPPORT_CHAT_EVENTS,
  SELLER_SUPPORT_CHAT_WS_NAMESPACE,
  SELLER_SUPPORT_CHAT_WS_PATH,
  type SellerSupportMessage,
} from '../types';

type Handlers = {
  onMessage?: (payload: { sellerId: number; message: SellerSupportMessage }) => void;
  onUnread?: (payload: { scope: 'seller' | 'admin'; count: number }) => void;
};

export function useSellerSupportChatSocket(handlers: Handlers, enabled = true) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!enabled) return undefined;

    const token = authUtils.getAccessToken();
    if (!token) return undefined;

    const socket: Socket = io(SELLER_SUPPORT_CHAT_WS_NAMESPACE, {
      path: SELLER_SUPPORT_CHAT_WS_PATH,
      transports: ['websocket', 'polling'],
      auth: {
        token,
        client: 'seller-admin',
      },
    });

    socket.on(SELLER_SUPPORT_CHAT_EVENTS.messageNew, (payload) => {
      handlersRef.current.onMessage?.(payload);
    });
    socket.on(SELLER_SUPPORT_CHAT_EVENTS.unread, (payload) => {
      handlersRef.current.onUnread?.(payload);
    });

    return () => {
      socket.disconnect();
    };
  }, [enabled]);
}
